module.exports = __webpack_public_path__ + "img/TESL_Ice_Storm.5bf9a4b6.jpg";